import DashboardLayout from "@/pages/layouts/DashboardLayout";

let forumRoutes = {
  path: '/forums',
  component: DashboardLayout,
  redirect: '/forums/list',
  children: [
    {
      path: 'list',
      name: 'Edition List',
      component: () => import(/* webpackChunkName: "forums" */  '@/pages/forums/ForumList'),
      meta: {
        permissionsCodes: ['forums/index'],
      }
    },
    {
      path: 'create',
      name: 'Add Edition',
      component: () => import(/* webpackChunkName: "forums" */  '@/pages/forums/ForumForm'),
      meta: {
        permissionsCodes: ['forums/create'],
      }
    },
    {
      path: 'edit/:id',
      name: 'Edit Edition',
      component: () => import(/* webpackChunkName: "forums" */  '@/pages/forums/ForumForm'),
      meta: {
        permissionsCodes: ['forums/update'],
      }
    },
    {
      path: 'manage-gallery/:id',
      name: 'Manage Gallery',
      component: () => import(/* webpackChunkName: "forums" */  '@/pages/forums/GalleryForm'),
      meta: {
        permissionsCodes: ['forums/manage-gallery'],
      }
    }
  ]
}

export default forumRoutes;
